import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../_redux/user-actions/UserActionsAction";
import { redirectToPages, resultAlert } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { UsernameAndPasswordChangeForm } from "./UsernameAndPasswordChangeForm";

export function UsernameAndPasswordChange({ history }) {
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, usernameAndPassword } = useSelector(
    (state) => ({
      actionsLoading: state.userActions.actionsLoading,
      isSuccess: state.userActions.isSuccess,
      type: state.userActions.type,
      usernameAndPassword: state.userActions.usernameAndPassword,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getUsername());
    return () => dispatch(actions.cleanUsername());
  }, [dispatch]);
  
  useEffect(() => {
    let _title = "Kullanıcı Adı ve Şifre Değiştirme";
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  /** Mevcut Kullanıcının Kullanıcı Adı ve Şifresini Günceller */
  const updateUsernameAndPassword = (values) => {
    dispatch(actions.updateUsernameAndPassword(values)).then((result) => onResult(result));
  };
  
  const btnRef = useRef();  
  const updateUsernameAndPasswordClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/dashboard`), 2500);
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <UsernameAndPasswordChangeForm 
            usernameAndPassword={usernameAndPassword}
            btnRef={btnRef} 
            updateUsernameAndPassword={updateUsernameAndPassword}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={updateUsernameAndPasswordClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}